import React, { useState } from "react";
import { Link } from "react-router-dom";

function Topbar() {
  const [showMenu, setShowMenu] = useState(false);

  const handleTheme = () => {
    document.body.classList.contains("light-theme")
      ? enableDarkMode()
      : enableLightMode();
  };

  function enableDarkMode() {
    const themeToggle = document.querySelector("#theme-toggle");
    document.body.classList.remove("light-theme");
    document.body.classList.add("dark-theme");
  }

  function enableLightMode() {
    const themeToggle = document.querySelector("#theme-toggle");
    document.body.classList.remove("dark-theme");
    document.body.classList.add("light-theme");
  }

  return (
    <div className="topbar">
      <header>
        <Link to="/" className="link">
          <div className="site-name">
            <span style={{ color: "darkgreen" }}>S</span>
            <span style={{ color: "orange" }}>T</span>
            <span style={{ color: "dodgerblue" }}>A</span>
            <span style={{ color: "green" }}>C</span>
            <span style={{ color: "red" }}>K</span>
            <span>ify</span>
          </div>
        </Link>

        <button onClick={handleTheme} id="theme-toggle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1.4rem"
            height="1.4rem"
            viewBox="0 0 472.39 472.39"
          >
            <g className="toggle-sun">
              <path d="M403.21,167V69.18H305.38L236.2,0,167,69.18H69.18V167L0,236.2l69.18,69.18v97.83H167l69.18,69.18,69.18-69.18h97.83V305.38l69.18-69.18Zm-167,198.17a129,129,0,1,1,129-129A129,129,0,0,1,236.2,365.19Z" />
            </g>
            <g className="toggle-circle">
              <circle className="cls-1" cx="236.2" cy="236.2" r="103.78" />
            </g>
          </svg>
        </button>

        <div className="search">
          <button>
            <span>SEARCH CONTENTS</span>
            <i
              style={{
                marginLeft: "4px",
                fontSize: "1.2rem",
              }}
              className="fas fa-search"
            ></i>
          </button>
        </div>

        <div className="navigation">
          <button
            className="technologies"
            onClick={() => setShowMenu(!showMenu)}
          >
            <span> TECHNOLOGIES</span>
            <i
              style={{
                marginLeft: "4px",
                fontSize: "1.2rem",
              }}
              className={showMenu ? "fas fa-times" : "fas fa-bars"}
            ></i>
          </button>

          <ul
            className={showMenu ? "navigationList show" : "navigationList"}
            onClick={() => setShowMenu(!showMenu)}
          >
            <li>
              <Link className="link" to="/html">
                HTML
              </Link>
            </li>

            <li>
              <Link className="link" to="/css">
                CSS
              </Link>
            </li>
            <li>
              <Link className="link" to="/javascript">
                JavaScript
              </Link>
            </li>
            <li>
              <Link className="link" to="/reactjs">
                ReactJS
              </Link>
            </li>
            <li>
              <Link className="link" to="/nodejs">
                NextJs
              </Link>
            </li>
            <li>
              <Link className="link" to="/nodejs">
                NodeJs
              </Link>
            </li>
            <li>
              <Link className="link" to="/expressjs">
                ExpressJS
              </Link>
            </li>
            <li>
              <Link className="link" to="/mongodb">
                MongoDB
              </Link>
            </li>
            <li>
              <Link className="link" to="/git-github">
                Git &#38; GitHub
              </Link>
            </li>
            <li>
              <Link className="link" to="/d3">
                D3
              </Link>
            </li>
          </ul>
        </div>
      </header>
    </div>
  );
}

export default Topbar;
